<template>
  <v-snackbar
      v-model="active"
      :color="color"
      :timeout="timeout"
      class="toast"
      location="center center"
      multi-line
    position="fixed"
  >
    <i :class="icon" class="toast-icon"/>
    <v-col color="transparent" class="toast-content ml-10">
      <span v-if="title" class="mb-1 text-h6 toast-title">{{ title }}</span>
      <span>{{ text }}</span>
      <v-btn
          v-if="actionText"
          color="white"
          variant="elevated"
          class="toast-action mt-4 mr-4"
          @click="handleAction"
      >
        <i v-if="actionIcon" :class="actionIcon" class="mr-2"/>
        {{ actionText }}
      </v-btn>
    </v-col>
    <template v-slot:actions>
      <v-btn
          icon
          @click="close"
      >
        <i class="fa-solid fa-xmark"/>
      </v-btn>
    </template>
  </v-snackbar>
</template>


<script>
export default {
  name: 'ModalToast',
  data() {
    return {
      active: false,
      timeout: -1,
      color: 'info',
      icon: 'fa-solid fa-circle-info',
      title: '',
      text: '',
      actionText: '',
      actionIcon: ''
    };
  },
  methods: {
    show(options = {}) {
      if (this.active) {
        this.close();
        this.$nextTick(() => this.show(options));
        return;
      }

      if (typeof options === 'string') {
        options = {text: options};
      }

      this.timeout = -1;
      this.color = 'info';
      this.icon = 'fa-solid fa-circle-info';
      this.title = '';
      this.text = '';
      this.actionText = '';
      this.actionIcon = '';

      Object.keys(options).forEach(field => (this[field] = options[field]));
      this.active = true;
    },
    handleAction() {
      this.$emit('action');
      this.close();
    },
    close() {
      this.active = false;
    }
  },
};
</script>
